import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

interface Props {
  allowPointerEvents: boolean;
  canOverflow: boolean;
  height: number | null;
}
const RailsSubListContainer = styled.div<Props>`
  height: ${(props) =>
    props.height ? `${props.height * Screen.widthRatio}px` : 'unset'};
  margin: 0 0 ${30 * Screen.widthRatio}px 0;
  overflow: ${(props) => (props.canOverflow ? 'hidden' : 'initial')};
  pointer-events: ${(props) => (props.allowPointerEvents ? 'all' : 'none')};
`;

export default RailsSubListContainer;
